import { Component, Input, TemplateRef, ViewChild } from '@angular/core';

/**
 * Accordion Panel Component
 *
 * Used as a child of app-accordion to define individual panels.
 */
@Component({
  selector: 'app-accordion-panel',
  standalone: false,
  template: `
    <ng-template #content>
      <ng-content></ng-content>
    </ng-template>
  `
})
export class AccordionPanelComponent {
  /** Unique identifier for the panel */
  @Input() id = '';

  /** Panel header title */
  @Input() title = '';

  /** Optional icon name (feather icon) */
  @Input() icon = '';

  /** Whether the panel is disabled */
  @Input() disabled = false;

  /** Optional subtitle */
  @Input() subtitle = '';

  @ViewChild('content', { static: true }) contentTemplate!: TemplateRef<unknown>;
}
